import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { BnUsuarioService, Usuario } from "@bndes/bndes-ux4/bn-usuario";
import { MessageChannelService, messageLevel, BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";
import { AcompanhamentoProcessualService } from './acompanhamento-processual.service';
import { EntradaAcompanhamentoProcessualOperacaoDTO, TIPOS_COBRANCA, FaseProcessual, EspecieAcaoRecurso } from '../../../model/acompanhamento-processual.model';
import { MensagemRetornoAssincrono } from 'src/app/model/mensagem-retorno-assincrono.model';
import { ProtocoloArquivoService } from '../../../shared/services/protocolo-arquivo.service';
import { OcorrenciaValidacaoVO } from 'src/app/shared/ocorrencia-validacao.vo';

@Component({
    templateUrl: './acompanhamento-processual-cadastro.component.html',
    styleUrls: ['./acompanhamento-processual-cadastro.component.scss'],
    standalone: false
})
export class AcompanhamentoProcessualCadastroComponent implements OnInit {

    private usuarioLogado: Usuario;

    public acompanhamentos: EntradaAcompanhamentoProcessualOperacaoDTO[];
    public tiposCobranca = TIPOS_COBRANCA;
    public fasesProcessuais: FaseProcessual[];
    public especiesAcaoRecurso: EspecieAcaoRecurso[];
    public limiteOperacoesCadastroViaTela = 250;
    public modoEdicao: boolean;
    public ocorrencias: OcorrenciaValidacaoVO[] = [];

    constructor(private service: AcompanhamentoProcessualService,
        private router: Router,
        private messageService: MessageChannelService,
        private usuarioService: BnUsuarioService,
        private protocoloArquivoService: ProtocoloArquivoService,
        private bnLoadingService: BnLoadingService) {
    }

    ngOnInit() {
        this.modoEdicao = true;

        this.service.getEspeciesAcaoRecurso().subscribe((resp) => {
            this.especiesAcaoRecurso = resp;
        });

        this.service.getFasesProcessuais().subscribe((resp) => {
            this.fasesProcessuais = resp;
        });

        this.usuarioService.usuario$.subscribe((usuario) => {
            this.usuarioLogado = usuario

            this.service.getOperacoesQuePrecisamSerInformadas(this.usuarioLogado.cnpj).subscribe((resp) => {
                this.acompanhamentos = [];
                for (let operacao of resp.operacoes) {
                    let acompanhamento = new EntradaAcompanhamentoProcessualOperacaoDTO();
                    acompanhamento.idOperacaoAgenteCreditoLivre = operacao.idOperacaoAgenteCreditoLivre;
                    acompanhamento.sistemaRepasse = operacao.sistemaRepasse;
                    acompanhamento.contratoRepasse = operacao.contratoRepasse;
                    this.acompanhamentos.push(acompanhamento);
                }
            });
        });
    }

    tipoCobrancaAlterado(acompanhamento: EntradaAcompanhamentoProcessualOperacaoDTO) {
        if (acompanhamento.tipoCobranca == 'E') {
            acompanhamento.especieAcaoRecurso = undefined;
            acompanhamento.faseProcessual = undefined;
            acompanhamento.numeroProcesso = undefined;
            acompanhamento.juizo = undefined;
            acompanhamento.comarca = undefined;
        }
    }

    cancelar() {
        this.router.navigate(['/acompanhamento-processual/pesquisa']);
    }

    geraEntradas(): EntradaAcompanhamentoProcessualOperacaoDTO[] {
        let entradas: EntradaAcompanhamentoProcessualOperacaoDTO[] = [];

        for (let acompanhamento of this.acompanhamentos) {
            let clone:any = {...acompanhamento};
            clone.cobrancaEncerrada = clone.cobrancaEncerrada ? "S" : "N";
            entradas.push(clone);
        }

        return entradas;
    }

    private preencheOcorrencias(csv: string) {
        let linhas = csv.split("\n");

        let primeiraLinha: boolean = true;

        for (let linha of linhas) {
            if (primeiraLinha) {
                primeiraLinha = false;
                continue;
            }
            let campos = linha.split(";");
            if (campos.length == 4 && campos[3].length > 0) {
                let ocorrencia = new OcorrenciaValidacaoVO(campos[3], 'E', campos[1].length ? campos[1] + " " + campos[2] : campos[0]);
                this.ocorrencias.push(ocorrencia);
            }
        }
    }

    private monitorarResultado(tentativa, idProtocolo) {
        this.protocoloArquivoService.statusSolicitacao(idProtocolo).subscribe ((status) => {
           if (status != 'AGUARDANDO_VALIDACAO') {
                this.bnLoadingService.liberaTela();
                this.protocoloArquivoService.getArquivoRespostaCsv(idProtocolo).subscribe ( 
                    (csv) => {
                        if (status == 'SUCESSO') {
                            this.modoEdicao = false;

                            const mensagemSucesso = `Protocolo realizado com sucesso. Id de protocolo: ${idProtocolo}`;

                            this.messageService.addMessage({
                                title: 'Sucesso',
                                type: 'CRUD_OPERATION',
                                level: messageLevel.SUCCESS,
                                message: mensagemSucesso
                                });
                        }
                        else if (status == 'ERRO') {
                            this.preencheOcorrencias(csv);

                            const mensagemErro = `Protocolo realizado com erro. Id de protocolo: ${idProtocolo}`;

                            this.messageService.addMessage({
                                title: 'Erro',
                                type: 'CRUD_OPERATION',
                                level: messageLevel.ERROR,
                                message: mensagemErro
                                });
                        }
                        else if (status == 'SUBSTITUIDO') {
                            const mensagemErro = `Protocolo substituído. Id de protocolo: ${idProtocolo}`;

                            this.messageService.addMessage({
                                title: 'Erro',
                                type: 'CRUD_OPERATION',
                                level: messageLevel.ERROR,
                                message: mensagemErro
                                });
                        }
                        else if (status == 'EXCLUIDO') {
                            const mensagemErro = `Protocolo excluído. Id de protocolo: ${idProtocolo}`;

                            this.messageService.addMessage({
                                title: 'Erro',
                                type: 'CRUD_OPERATION',
                                level: messageLevel.ERROR,
                                message: mensagemErro
                                });
                        }
                        else {
                            const mensagemErro = `Protocolo com status inválido. Id de protocolo: ${idProtocolo}`;

                            this.messageService.addMessage({
                                title: 'Erro',
                                type: 'CRUD_OPERATION',
                                level: messageLevel.ERROR,
                                message: mensagemErro
                                });
                        }
                    });
           }
           else {
            if (tentativa > 100) {
                const mensagemErro = `Tempo de resposta excedido. Utilize a tela de consulta de arquivos para ver o resultado. Id de protocolo: ${idProtocolo}`;

                this.messageService.addMessage({
                    title: 'Erro',
                    type: 'CRUD_OPERATION',
                    level: messageLevel.ERROR,
                    message: mensagemErro
                    });
               }
               else {
                setTimeout(() => this.monitorarResultado(tentativa+1, idProtocolo), 5000);
               }
           }
        });
    }

    salvar() {
        this.ocorrencias = [];

        this.bnLoadingService.bloqueiaTela();

        this.service.salvarLote({operacoes: this.geraEntradas()}, false).subscribe((resp) => {
            const msgRetorno = (<MensagemRetornoAssincrono> resp);

            const idProtocolo = msgRetorno.idProtocolo;

            this.monitorarResultado(1, idProtocolo);
        });
    }

}